export default __webpack_public_path__ + "static/logo-ba74c93e484c7c536a377986e6fca2e4.svg";